import { render, staticRenderFns } from "./ResponsiveDatatable.vue?vue&type=template&id=5149bf53&"
import script from "./ResponsiveDatatable.vue?vue&type=script&lang=js&"
export * from "./ResponsiveDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports